<template>
    <div :class="classes">
        <svg
            v-if="active"
            :style="styles"
            :class="theme.circular"
            viewBox="25 25 50 50"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                :class="theme.path"
                cx="50" cy="50" r="20"
                fill="none" stroke-width="5"
            />
        </svg>

        <slot></slot>
    </div>
</template>
<script>
    import theme from './spinner.scss'

    export default {
        name: 'spinner',
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            },
            active: {
                type: Boolean,
                default: true,
            },
            size: {
                type: Number,
                default: 36,
            },
            block: {
                type: Boolean,
                default: false,
            },
            transparent: {
                type: Boolean,
                default: false,
            },
            green: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            classes() {
                return {
                    [theme.loader]: true,
                    [theme.isActive]: this.active,
                    [theme.isBlock]: this.block,
                    [theme.isTransparent]: this.transparent,
                    [theme.isGreen]: this.green,
                }
            },
            styles() {
                return {
                    width: this.size + 'px',
                    height: this.size + 'px',
                    marginTop: this.size / -2 + 'px',
                    marginLeft: this.size / -2 + 'px',
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Spinner.vue?18d4cc5b